import store from '../../../../../store';
import {
  SET_DOCUMENTS_CHOSEN_FILTER,
  SET_DOCUMENTS_CHOSEN_FILTER_NAME,
  SET_DOCUMENTS_FILTERS,
  SET_DOCUMENTS_FILTERS_ERROR,
  SET_DOCUMENTS_FILTERS_LOADING,
} from './actionTypes';
import { client } from '../../../../../actions';
import { authHeader } from '../../../../../helpers/auth-header';
import { FILTER_URL } from './constants';
import { setDocumentFilterValues } from '../documents.actions';

export const saveDocumentFilter = (name) => {
  return async (dispatch) => {
    dispatch(setDocumentFiltersLoading(true));
    const {
      dateRange,
      dateRangeField,
      valueType,
      valueSubType,
      valueStatus,
      valueExecuter,
      responsibleWorker,
      valueCreator,
      valueCompany,
      valueAddrStreet,
      valueAddrBuilding,
      valueAddrFlat,
      valueServiceCompany,
    } = store.getState().documentsStore;

    const filterToSave = {
      dateRange,
      dateRangeField,
      valueType,
      valueSubType,
      valueStatus,
      valueExecuter,
      responsibleWorker,
      valueCreator,
      valueCompany,
      valueAddrStreet,
      valueAddrBuilding,
      valueAddrFlat,
      valueServiceCompany,
    };

    console.log('filterToSave', filterToSave);
    const existingFilters = store.getState().documentFilterStore.filters.data;

    const filterToUpdate = existingFilters.filter((existingFilter) => {
      return existingFilter.name === name;
    });

    if (filterToUpdate?.length > 0) {
      const response = await client.put(
        FILTER_URL,
        {
          Filter: JSON.stringify(filterToSave),
          name,
          id: filterToUpdate[0].id,
          Type: 'DOCS',
        },
        { headers: authHeader() }
      );
    } else {
      const response = await client.post(
        FILTER_URL,
        {
          Filter: JSON.stringify(filterToSave),
          name,
          Type: 'DOCS',
        },
        { headers: authHeader() }
      );
    }
    dispatch(fetchDocumentFilters());
  };
};

export const fetchDocumentFilters = () => {
  return async (dispatch) => {
    dispatch(setDocumentFiltersLoading(true));
    const response = await client.get(FILTER_URL, {
      headers: authHeader(),
      params: { type: 'DOCS' },
    });
    dispatch(setDocumentFilters(response.data));
  };
};

export const setDocumentFilters = (payload) => {
  return {
    type: SET_DOCUMENTS_FILTERS,
    payload: payload,
  };
};

export const setDocumentFiltersError = (payload) => {
  return {
    type: SET_DOCUMENTS_FILTERS_ERROR,
    payload: payload,
  };
};

export const setDocumentFiltersLoading = (payload) => {
  return {
    type: SET_DOCUMENTS_FILTERS_LOADING,
    payload: payload,
  };
};

export const setChosenDocumentsFilter = (payload) => {
  return {
    type: SET_DOCUMENTS_CHOSEN_FILTER,
    payload: payload,
  };
};

export const setChosenDocumentsFilterName = (payload) => {
  return {
    type: SET_DOCUMENTS_CHOSEN_FILTER_NAME,
    payload: payload,
  };
};

export const chooseDocumentFilter = (id) => {
  return (dispatch) => {
    const existingFilters = store.getState().documentFilterStore.filters.data;

    const chosenFilter = existingFilters.filter((existingFilter) => {
      return existingFilter.id === id;
    });

    dispatch(setChosenDocumentsFilter(chosenFilter[0].id));
    dispatch(setChosenDocumentsFilterName(chosenFilter[0].name.trim()));
    dispatch(setDocumentFilterValues(JSON.parse(chosenFilter[0].filter)));
  };
};

export const removeSelectionFromDefaultFilter = () => {
  return (dispatch) => {
    dispatch(setChosenDocumentsFilter(null));
    dispatch(setChosenDocumentsFilterName(null));
  };
};

export const deleteDocumentFilter = (id) => {
  return async (dispatch) => {
    dispatch(setDocumentFiltersLoading(true));
    const response = await client.delete(FILTER_URL, {
      headers: authHeader(),
      params: { id },
    });
    dispatch(fetchDocumentFilters());
  };
};
